module.exports = __webpack_public_path__ + "static/media/az.c9be60f9.svg";